import { z } from 'zod';

import type { UserRole } from '~/api/types';
import { USER_ROLES, type UserRoleValue } from '~/features/auth/roles';

const nameRegex = /^[\w@#\-()*'" ]+$/;

export const validRoles: UserRoleValue[] = [
  USER_ROLES.NonHcpAdmin,
  USER_ROLES.HcpAdmin,
  USER_ROLES.HcpUser,
];

export const basicUserSchema = z.object({
  firstName: z
    .string()
    .min(1, 'First Name is required')
    .regex(nameRegex, 'Should be valid')
    .max(40, 'First Name is too long'),
  lastName: z
    .string()
    .min(1, 'Last Name is required')
    .regex(nameRegex, 'Should be valid')
    .max(80, 'Last Name is too long'),
  email: z.email(),
  phone: z.e164('Invalid phone number').or(z.literal('')).optional(),
  role: z.custom<UserRole>().optional(),
  departmentId: z.string().optional(),
});

export const userSchema = basicUserSchema.safeExtend({
  role: z.custom<UserRole>().refine((role) => validRoles.includes(role), {
    message: 'Role is required',
  }),
});
